// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2jbrC","list":"BalanceDue_list__yC0BY","listRow":"BalanceDue_listRow__tIpFh","total":"BalanceDue_total__3bS4n"};